<template>
  <v-menu min-width="200" bottom left transition="slide-y-transition" :close-on-content-click="false">
    <template #activator="{ on }">
      <v-btn x-small>
        <v-icon small v-on="on">mdi-cog</v-icon>
      </v-btn>
    </template>
    <template>
      <div class="border-wrap">
        <v-list dense>
          <v-list-group no-action>
            <template v-slot:activator>
              <v-list-item-title>{{ $t('motlet.settings.grid.column') }}</v-list-item-title>
            </template>
            <v-card class="card-wrap">
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-data-table
                v-model="selectedFileds"
                :headers="headers"
                :items="items"
                :fixed-header="true"
                :disable-pagination="true"
                item-key="value"
                height="156"
                class="elevation-0 content"
                show-select
                dense 
                hide-default-footer>
              </v-data-table>
            </v-card>
          </v-list-group>
        </v-list>
      </div>
    </template>
  </v-menu>
  <!--v-menu min-width="300">
    <template #activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" x-small>
        <v-icon small>mdi-format-list-checks</v-icon>
      </v-btn>
    </template>
    <v-card class="card-wrap">
      <v-card class="pa-1 my-2 elevation-0">
        <v-data-table
          v-model="selectedFileds"
          :headers="headers"
          :items="items"
          :fixed-header="true"
          :disable-pagination="true"
          item-key="value"
          height="192"
          class="elevation-0 content"
          show-select
          dense 
          hide-default-footer>
        </v-data-table>
      </v-card>
    </v-card>
  </v-menu-->
</template>

<script>
import bus from '@/utils/bus';
import settingsGrid from './grid';

export default {
  props: {
    code: {
      type: String,
      required: true,
    },
    selected: {
      type: Array,
      required: true,
    },
    storeName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      headers: [{ text: this.$t('common.select.all'), value: 'text', sortable: false }],
    };
  },
  watch: {
    selectedFileds(value) {
      if (!this.fixedFields.every(v => value.map(s => s.value).includes(v))) {
        const finds = this.fixedFields.filter(v => !value.map(s => s.value).includes(v));
        const adds = this.items.filter(s => finds.includes(s.value));
        this.setSelected(value.concat(adds));
      }
    },
  },
  computed: {
    fixedFields() {
      return this.items.filter((s, i) => i < 1).map(s => s.value);
    },
    items() {
      return settingsGrid[this.code].fields;
    },
    selectedFileds: {
      get() {
        return this.items.filter(f => this.selected.includes(f.value));
      },
      set(value) {
        this.setSelected(value);
      },
    },
  },
  methods: {
    setSelected(value) {
      bus.$emit(`change:selected-fields-${this.storeName}`, { code: this.code, fields: value.map(f => f.value) });
    },
  },
};
</script>
